import { Text } from '@chakra-ui/react'
import React from 'react'

interface PromotionDiscountBannerProps {
  promotionText: string
}

const PromotionDiscountBanner = ({
  promotionText
}: PromotionDiscountBannerProps) => {
  return (
    <Text
      fontSize="16px"
      color="white"
      px={4}
      py={3}
      bg="#0d8443"
      borderRadius="lg"
      mt={4}
      textAlign="center"
      dangerouslySetInnerHTML={{ __html: promotionText }}
    />
  )
}
export default PromotionDiscountBanner
